import { jsxs, jsx } from "react/jsx-runtime";
import { c } from "react-compiler-runtime";
import { useState } from "react";
import { isObjectType, isInterfaceType, isInputObjectType } from "graphql";
import { Button, ChevronDownIcon, ChevronUpIcon } from "@graphiql/react";
import { useDocExplorerActions } from "../context.js";
import { TypeLink } from "./type-link.js";
import { renderType } from "./utils.js";
/* empty css                */
const FieldsList = (t0) => {
  const $ = c(23);
  const {
    type,
    activeFieldName
  } = t0;
  const [expanded, setExpanded] = useState(true);
  const [showDeprecated, setShowDeprecated] = useState(false);
  if (!isObjectType(type) && !isInterfaceType(type) && !isInputObjectType(type)) {
    return null;
  }
  let t1;
  if ($[0] !== type) {
    t1 = type.getFields();
    $[0] = type;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const fieldMap = t1;
  let deprecatedFields;
  let fields;
  if ($[2] !== fieldMap) {
    fields = [];
    deprecatedFields = [];
    for (const field of Object.values(fieldMap)) {
      if (field.deprecationReason) {
        deprecatedFields.push(field);
      } else {
        fields.push(field);
      }
    }
    $[2] = fieldMap;
    $[3] = deprecatedFields;
    $[4] = fields;
  } else {
    deprecatedFields = $[3];
    fields = $[4];
  }
  const totalCount = fields.length + (showDeprecated ? deprecatedFields.length : 0);
  let t2;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = () => setExpanded(_temp);
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] !== expanded) {
    t3 = expanded ? /* @__PURE__ */ jsx(ChevronDownIcon, { "aria-hidden": "true" }) : /* @__PURE__ */ jsx(ChevronUpIcon, { "aria-hidden": "true" });
    $[6] = expanded;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] !== totalCount) {
    t4 = /* @__PURE__ */ jsxs("span", { children: [
      "FIELDS",
      " ",
      /* @__PURE__ */ jsxs("span", { className: "graphiql-doc-explorer-fields-list-count", children: [
        "· ",
        totalCount
      ] })
    ] });
    $[8] = totalCount;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  let t5;
  if ($[10] !== expanded || $[11] !== t3 || $[12] !== t4) {
    t5 = /* @__PURE__ */ jsxs("button", { type: "button", className: "graphiql-doc-explorer-fields-list-header", onClick: t2, "aria-expanded": expanded, children: [
      t3,
      t4
    ] });
    $[10] = expanded;
    $[11] = t3;
    $[12] = t4;
    $[13] = t5;
  } else {
    t5 = $[13];
  }
  let t6;
  if ($[14] !== activeFieldName || $[15] !== deprecatedFields || $[16] !== expanded || $[17] !== fields || $[18] !== showDeprecated) {
    t6 = expanded && /* @__PURE__ */ jsxs("div", { className: "graphiql-doc-explorer-fields-list-body", children: [
      fields.map((field_0) => /* @__PURE__ */ jsx(FieldRow, { field: field_0, isActive: field_0.name === activeFieldName }, field_0.name)),
      deprecatedFields.length > 0 && (showDeprecated || fields.length === 0 ? deprecatedFields.map((field_1) => /* @__PURE__ */ jsx(FieldRow, { field: field_1, isActive: field_1.name === activeFieldName, deprecated: true }, field_1.name)) : /* @__PURE__ */ jsx(Button, { type: "button", onClick: () => setShowDeprecated(true), className: "graphiql-doc-explorer-fields-list-show-deprecated", children: "Show Deprecated Fields" }))
    ] });
    $[14] = activeFieldName;
    $[15] = deprecatedFields;
    $[16] = expanded;
    $[17] = fields;
    $[18] = showDeprecated;
    $[19] = t6;
  } else {
    t6 = $[19];
  }
  let t7;
  if ($[20] !== t5 || $[21] !== t6) {
    t7 = /* @__PURE__ */ jsxs("div", { className: "graphiql-doc-explorer-fields-list", children: [
      t5,
      t6
    ] });
    $[20] = t5;
    $[21] = t6;
    $[22] = t7;
  } else {
    t7 = $[22];
  }
  return t7;
};
const FieldRow = (t0) => {
  const $ = c(24);
  const {
    field,
    isActive,
    deprecated
  } = t0;
  const {
    push
  } = useDocExplorerActions();
  const t1 = isActive ? "graphiql-doc-explorer-field-row--active" : "";
  const t2 = deprecated ? "graphiql-doc-explorer-field-row--deprecated" : "";
  let t3;
  if ($[0] !== t1 || $[1] !== t2) {
    t3 = ["graphiql-doc-explorer-field-row", t1, t2].filter(Boolean);
    $[0] = t1;
    $[1] = t2;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  const t4 = t3.join(" ");
  let t5;
  if ($[3] !== field || $[4] !== push) {
    t5 = () => push({
      name: field.name,
      def: field
    });
    $[3] = field;
    $[4] = push;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  const t6 = isActive ? "true" : void 0;
  let t7;
  if ($[6] !== field.name) {
    t7 = /* @__PURE__ */ jsx("span", { className: "graphiql-doc-explorer-field-row-name", children: field.name });
    $[6] = field.name;
    $[7] = t7;
  } else {
    t7 = $[7];
  }
  let t8;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = /* @__PURE__ */ jsx("span", { className: "graphiql-doc-explorer-field-row-colon", children: ":" });
    $[8] = t8;
  } else {
    t8 = $[8];
  }
  let t9;
  if ($[9] !== field.type) {
    t9 = renderType(field.type, _temp2);
    $[9] = field.type;
    $[10] = t9;
  } else {
    t9 = $[10];
  }
  let t10;
  if ($[11] !== t9) {
    t10 = /* @__PURE__ */ jsx("span", { className: "graphiql-doc-explorer-field-row-type", children: t9 });
    $[11] = t9;
    $[12] = t10;
  } else {
    t10 = $[12];
  }
  let t11;
  if ($[13] !== t10 || $[14] !== t7) {
    t11 = /* @__PURE__ */ jsxs("div", { className: "graphiql-doc-explorer-field-row-sig", children: [
      t7,
      t8,
      t10
    ] });
    $[13] = t10;
    $[14] = t7;
    $[15] = t11;
  } else {
    t11 = $[15];
  }
  let t12;
  if ($[16] !== field.description) {
    t12 = field.description && /* @__PURE__ */ jsx("div", { className: "graphiql-doc-explorer-field-row-desc", children: field.description });
    $[16] = field.description;
    $[17] = t12;
  } else {
    t12 = $[17];
  }
  let t13;
  if ($[18] !== t11 || $[19] !== t12 || $[20] !== t4 || $[21] !== t5 || $[22] !== t6) {
    t13 = /* @__PURE__ */ jsxs("button", { type: "button", className: t4, onClick: t5, "aria-current": t6, children: [
      t11,
      t12
    ] });
    $[18] = t11;
    $[19] = t12;
    $[20] = t4;
    $[21] = t5;
    $[22] = t6;
    $[23] = t13;
  } else {
    t13 = $[23];
  }
  return t13;
};
function _temp(e) {
  return !e;
}
function _temp2(namedType) {
  return /* @__PURE__ */ jsx(TypeLink, { type: namedType });
}
export {
  FieldsList
};
//# sourceMappingURL=fields-list.js.map
